/**
 * @flow
 */
import React from 'react';
import { format, addMonths, startOfMonth } from 'date-fns';
import { useQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { map, get } from 'lodash';
import gql from 'graphql-tag';

import { setDate } from '../../../actions/master-appointments';
import ReportDateRange from '../../report/components/DateRange';

export const GET_WORKING_DAYS = gql`
    query getWorkingDays(
        $salon: ID!
        $master: ID!
        $fromDate: String!
        $toDate: String!
    ) {
        viewer {
            id
            ... on Administrator {
                salon(id: $salon) {
                    id
                    name
                    workingDays(
                        master: $master
                        fromDate: $fromDate
                        toDate: $toDate
                    ) {
                        date
                        appointmentCount
                    }
                }
            }
        }
    }
`;

function DateRange() {
    const salon = useSelector(({ user }) => user.get('salon'));
    const masterObj = useSelector(({ masterAppointments }) =>
        masterAppointments.get('master'),
    );
    const master = masterObj && masterObj.id;
    const fromDate = useSelector(({ masterAppointments }) =>
        new Date(masterAppointments.get('fromDate')),
    );
    const toDate = useSelector(({ masterAppointments }) =>
        new Date(masterAppointments.get('toDate')),
    );
    const dispatch = useDispatch();

    // Compute extended range for working days calendar (today to ~6 months out)
    const from = format(new Date(), 'yyyy-MM-dd');
    const to = format(addMonths(startOfMonth(new Date()), 6), 'yyyy-MM-dd');

    const { data, loading } = useQuery(GET_WORKING_DAYS, {
        variables: { salon, master, fromDate: from, toDate: to },
        skip: !salon || !master,
    });

    const workingDays = map(
        get(data, 'viewer.salon.workingDays', []),
        item => new Date(item.date),
    );

    return (
        <ReportDateRange
            loading={loading}
            workingDays={workingDays}
            from={fromDate}
            to={toDate}
            fromDate={fromDate}
            toDate={toDate}
            onChange={date => dispatch(setDate(date))}
        />
    );
}

export default DateRange;
